// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"MobilePlayerGiftButton__buttonWrapper__2tUtQ","embedWrapper":"MobilePlayerGiftButton__embedWrapper__3qx_z"};